import React from 'react'

import styled from '@emotion/styled'
import { mq, black01, pcHeaderH, spHeaderH, hoverFade, breakP, grayBorder, baseDurationTime, green01 } from '../../_style'
import { Link } from 'gatsby';
import Logo from '../atoms/logo';
import ClassNames from 'classnames';
import BannerList from '../molecules/bannerList';
import arrow from '../../assets/imgs/icon-arrow.svg';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';


const HeaderContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  display: flex;
  font-weight: 300;
  justify-content: space-between;
  z-index: 8000;
  transition: background-color ${baseDurationTime} ease, box-shadow ${baseDurationTime} ease;
  [data-block-header] &, [data-small-header] & {
    background-color: #fff;
  }
  [data-small-header] & {
    position: relative;
    top: 0;
  }
  ${mq.pc} {
    &.is-fixed {
      position: fixed;
      top: 0;
      background-color: #fff;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
    }
  }
`
const HeaderInner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  max-width: 1180px;
  margin: auto;
  padding: 0 50px;
  box-sizing: content-box;
  ${mq.sp} {
    justify-content: space-between;
    padding: 25px 20px 25px 16px;
  }
`
const HeaderLogo = styled.div`
  z-index: 1000;
  span {
    display: block;
    font-size: 12px;
    margin-top: 13px;
    ${mq.sp} {
      font-size: 10px;
    }
  }
  a {
    display: block;
    ${hoverFade}
    text-shadow:1px 1px 0px rgba(255, 255, 255, 0.6);
    transition: transform ${baseDurationTime} ease , opacity ${baseDurationTime} ease;
    transform-origin: center left;
    will-change: transform;
    ${mq.pc} {
      .is-fixed &, [data-small-header] & {
        transform: scale3d(${72 / 125}, ${72 / 125}, 1);
      }
    }
    svg {
      display: block;
      width: 125px;
      height: 63px;
      ${mq.sp} {
        width: 91px;
        height: 47px;
      }
    }
  }
`;

const HeaderNav = styled.div`
  ${mq.pc} {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
  }
  ${mq.sp} {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    z-index: 9000;
    opacity: 0;
    pointer-events: none;
    transition: opacity ${baseDurationTime} ease;
    .is-menu-open & {
      opacity: 1;
      pointer-events: all;
    }
  }
  & > ul {
    padding: 35px 0;
    letter-spacing: 0.2em;
    font-size: 12px;
    transition: padding ${baseDurationTime} ease;
    ${mq.pc} {
      display: flex;
      .is-fixed &, [data-small-header] & {
        padding: 13px 0 14px;
      }
    }
    ${mq.sp} {
      padding: 120px 20px 0;
      font-size: 16px;
    }
    li {
      &.is-current a {
        opacity: 0.5;
      }
      ${mq.pc} {
        &:not(:last-of-type) {
          margin-right: 6px;
        }
      }
      ${mq.sp} {
        border-top: 1px solid ${grayBorder};
        &:last-of-type {
          border-bottom: 1px solid ${grayBorder};
        }
      }

      & > a {
        display: block;
        padding: 10px 12px;
        font-size: 14px;
        line-height: 1;
        letter-spacing: 0.16em;
        color: ${black01};
        transition: color ${baseDurationTime} ease;
        ${mq.pc} {
          &:hover {
            color: ${green01};
          }
        }
        ${mq.sp} {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 25px 0;
          &::after {
            content: "";
            display: block;
            width: 6px;
            height: 10px;
            background-image: url(${arrow});
            background-size: contain;
          }
        }
      }
    }
  }
`;

const HeaderNavLogo = styled(Link)`
  ${mq.pc} {
    display: none;
  }
  ${mq.sp} {
    position: absolute;
    top: 25px;
    left: 16px;
    svg {
      width: 91px;
      height: 47px;
    }
  }
`
const HeaderBtn = styled.button`
  ${mq.pc} {
    display: none;
  }
  ${mq.sp} {
    display: block;
    position: relative;
    width: 30px;
    height: 30px;
    .is-fixed & {
      position: fixed;
      top: 33px;
      right: 20px;
    }
    span {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: ${black01};
      &:first-of-type {
        top: 7px;
      }
      &:nth-of-type(2) {
        top: 14px;
      }
      &:last-of-type {
        top: 21px;
      }
    }
  }
`
const CloseBtn = styled.button`
  ${mq.pc} {
    display: none;
  }
  position: absolute;
  top: 30px;
  right: 20px;
  width: 16px;
  height: 16px;
  &::before, &::after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 22px;
    height: 1px;
    margin: auto;
    background-color: ${black01};
  }
  &::before {
    transform: rotate(45deg);
  }
  &::after {
    transform: rotate(-45deg);
  }
`

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {isMenuOpen: false, activeMenuNum: 0, isFixed: false, isSp: false, path: ''};
    this.scrollHandler = this.scrollHandler.bind(this);
    this.resizeHandler = this.resizeHandler.bind(this);
  }
  componentDidMount() {
    this.setState({isSp: breakP >= window.innerWidth, path: location.href});
    this.headerTopPos = this.header.getBoundingClientRect().top + window.pageYOffset;
    window.addEventListener('scroll', this.scrollHandler);
    window.addEventListener('resize', this.resizeHandler);
  }
  componentWillUnmount() {
    document.body.classList.remove('is-menu-open');
    enableBodyScroll(this.nav);
    window.removeEventListener('scroll', this.scrollHandler);
    window.removeEventListener('resize', this.resizeHandler);
  }
  resizeHandler() {
    this.setState({isSp: breakP >= window.innerWidth});
  }
  scrollHandler() {
    if(this.header.getBoundingClientRect().top !== 0) this.headerTopPos = this.header.getBoundingClientRect().top + window.pageYOffset;
    if(window.pageYOffset > this.headerTopPos) {
      this.setState({isFixed: true});
    } else {
      this.setState({isFixed: false});
    }
  }
  menuHandler(isOpen) {
    if(isOpen) {
      disableBodyScroll(this.nav);
      document.body.classList.add('is-menu-open');
    } else {
      enableBodyScroll(this.nav);
      document.body.classList.remove('is-menu-open');
    }
    this.setState({isMenuOpen: isOpen});
  }
  render() {
    const addClass = ClassNames({'is-fixed': this.state.isFixed});
    return(
      <HeaderContainer ref={header => this.header = header} className={addClass}>
        <HeaderInner>
          <HeaderLogo>
            <Link to="/">
              <Logo></Logo>
            </Link>
          </HeaderLogo>
          <HeaderNav ref={nav => this.nav = nav}>
            <HeaderNavLogo to="/"><Logo></Logo></HeaderNavLogo>
            <CloseBtn onClick={() => this.menuHandler(false)}></CloseBtn>
            <ul>
              <li><Link to="/">トップ</Link></li>
              <li className={this.state.path.indexOf('lineup') > -1 ? 'is-current' : null}><Link to="/lineup">ラインナップ</Link></li>
              <li className={this.state.path.indexOf('about') > -1 ? 'is-current' : null}><Link to="/about">モンダミンについて</Link></li>
              <li className={this.state.path.indexOf('column') > -1 ? 'is-current' : null}><Link to="/column">お口の健康コラム</Link></li>
            </ul>
            {this.state.isSp && <BannerList banners={[{href: 'https://www.earth.jp/dental/index.html',img: 'img-banner-dental',alt: 'デンタル',isBlank: true,}, {to: '/premiumcare', img: 'img-banner-all-in-one', alt: 'プレミアム', isNew: false}, {href: 'https://www.earth.jp/mondahmin-kids/index.html', img: 'img-banner-kids', alt: 'キッズ', isBlank: true}]} inNav></BannerList>}
          </HeaderNav>
          <HeaderBtn onClick={() => this.menuHandler(true)}>
            <span></span>
            <span></span>
            <span></span>
          </HeaderBtn>
        </HeaderInner>
      </HeaderContainer>
    )
  }
}
